var _rect, _rect2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconBonusMotivation = function SvgIconBonusMotivation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#fff",
    rx: 8
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 7.53,
    height: 2.347,
    x: 4,
    y: 5.886,
    stroke: "#798897",
    rx: 1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#798897",
    d: "M10.582 8.233v3.298c0 .259-.21.469-.469.469h-4.69a.47.47 0 0 1-.47-.47V8.234M7.768 5.886V12M7.768 5.886S7.806 4 5.953 4c-.428 0-1 .262-.91.978.09.715 1.031.908 1.031.908"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#798897",
    d: "M7.769 5.886S7.73 4 9.583 4c.429 0 1 .262.91.978-.09.715-1.031.908-1.031.908"
  })));
};
export { SvgIconBonusMotivation as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjE2IiBoZWlnaHQ9IjE2IiByeD0iOCIgZmlsbD0id2hpdGUiLz4KPHJlY3QgeD0iNCIgeT0iNS44ODYwOCIgd2lkdGg9IjcuNTMwMDgiIGhlaWdodD0iMi4zNDcyOSIgcng9IjEiIHN0cm9rZT0iIzc5ODg5NyIvPgo8cGF0aCBkPSJNMTAuNTgyNCA4LjIzMzRWMTEuNTMwNkMxMC41ODI0IDExLjc4OTggMTAuMzcyMyAxMiAxMC4xMTMgMTJINS40MjIzNUM1LjE2MzA4IDEyIDQuOTUyOSAxMS43ODk4IDQuOTUyOSAxMS41MzA2VjguMjMzNCIgc3Ryb2tlPSIjNzk4ODk3Ii8+CjxwYXRoIGQ9Ik03Ljc2NzcgNS44ODYwOFYxMiIgc3Ryb2tlPSIjNzk4ODk3Ii8+CjxwYXRoIGQ9Ik03Ljc2NzcxIDUuODg2MDlDNy43Njc3MSA1Ljg4NjA5IDcuODA2MTIgNCA1Ljk1MzM2IDRDNS41MjQ1MyA0IDQuOTUyOTMgNC4yNjIzIDUuMDQyNjQgNC45Nzc2M0M1LjEzMjM2IDUuNjkyOTUgNi4wNzQzMSA1Ljg4NjA5IDYuMDc0MzEgNS44ODYwOSIgc3Ryb2tlPSIjNzk4ODk3Ii8+CjxwYXRoIGQ9Ik03Ljc2ODUgNS44ODYwOUM3Ljc2ODUgNS44ODYwOSA3LjczMDA5IDQgOS41ODI4NSA0QzEwLjAxMTcgNCAxMC41ODMzIDQuMjYyMyAxMC40OTM2IDQuOTc3NjNDMTAuNDAzOCA1LjY5Mjk1IDkuNDYxOSA1Ljg4NjA5IDkuNDYxOSA1Ljg4NjA5IiBzdHJva2U9IiM3OTg4OTciLz4KPC9zdmc+Cg==";